import React, { useState, useEffect, Fragment } from 'react';
import { Text } from 'porosys-ui';
import { useLocation, Link } from 'react-router-dom';
import { getUsersAcl } from '../../../../../app/User/api';
import './styles.scss';
import { POROSYS_CLIENT_URL } from '../../../../services/api/address';

const MenuBar = () => {
    const currentPath = useLocation().pathname;

    const [usersAcl, setUsersAcl] = useState({});

    useEffect(() => {
        const fetchUsersAcl = async () => {
            setUsersAcl(await getUsersAcl());
        };

        fetchUsersAcl();
    }, []);

    const menuItems = [
        {
            title: 'جلسات',
            path: '/',
        },
        {
            title: 'لیست اقدامات',
            path: '/actions',
        },
        {
            title: 'لیست تصمیمات',
            path: '/policies',
        },
        usersAcl.view
            ? {
                  title: 'کاربران',
                  path: '/users',
              }
            : null,
        {
            title: 'پروسیس',
            path: '',
            onClick: e => gotoPorosys(e),
        },
    ];

    const gotoPorosys = event => {
        event.preventDefault();

        const registeredToken = localStorage.getItem('token');
        if (!registeredToken) return;

        const separator = POROSYS_CLIENT_URL.includes('?') ? '&' : '?';
        window.open(`${POROSYS_CLIENT_URL}${separator}token=${encodeURIComponent(registeredToken)}`, '_blank');
    };

    return (
        <Fragment>
            <div className="menu-bar">
                {menuItems.map((item, i) => (
                    <div key={i}>
                        {item &&
                            (item.path.startsWith('http') ? (
                                <a
                                    onClick={e => (item.onClick ? item.onClick(e) : null)}
                                    className={`menu-item ${item.path === currentPath && item && 'selected'}`}
                                    href={item.path}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <Text classes={{ root: 'menu-item-text' }}>{item.title}</Text>
                                </a>
                            ) : (
                                <Link
                                    onClick={e => (item.onClick ? item.onClick(e) : null)}
                                    className={`menu-item ${item.path === currentPath && item && 'selected'}`}
                                    to={item.path}
                                >
                                    <Text classes={{ root: 'menu-item-text' }}>{item.title}</Text>
                                </Link>
                            ))}
                    </div>
                ))}
            </div>
        </Fragment>
    );
};

export default MenuBar;
